import { render, staticRenderFns } from "./Objective.vue?vue&type=template&id=604ecec9&"
import script from "./Objective.vue?vue&type=script&lang=js&"
export * from "./Objective.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports